export default __webpack_public_path__ + "static/media/grid.6c290324.svg";